import styled from "styled-components";

export const GamesOpenSessionCalendarIconDefaultBox = styled.div`
  width: 17px;
  height: 17px;
  background-image: url("${props => props.theme.images.gamingHistory.calendar.toString()}");
  background-repeat: no-repeat;
  background-size: 17px 17px;

  @media ${({theme}) => theme.mediaQuery.mAndAbove} {
    width: 25px;
    height: 25px;
    background-size: 25px 25px;
  }
`